import React from 'react'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Translate, I18n, setLocale } from 'react-redux-i18n'
import moment from 'moment'
import classNames from 'classnames'

import { signOut } from 'modules/users/sign_out'
import { toggleLanguageDialog, toggleMobileMenu } from 'modules/translations'
import Counter from 'components/Countdown'
import NavItem from '../nav/item'
import LanguageDialog from './languages'
import parametersSelector from 'selectors/parameters'
import jsonSelector from 'selectors/json'

const Menu = ({ onClick, signOut, mobile, user_signed_in, config_parameters, className }) => (
  <ul className={className} onClick={onClick}>
    <NavItem to="https://tokensale.shping.com">{I18n.t('nav.home')}</NavItem>
    <NavItem to="https://tokensale.shping.com/about-us.html">{I18n.t('nav.about')}</NavItem>
    {config_parameters['links.white_paper'] && (
      <NavItem to={config_parameters['links.white_paper']}>{I18n.t('nav.white_paper')}</NavItem>
    )}
    <NavItem to="http://blog.shping.com/tokensale">{I18n.t('nav.news')}</NavItem>
    {config_parameters['links.faq'] && (
      <NavItem to={config_parameters['links.faq']}>{I18n.t('nav.faq')}</NavItem>
    )}
    <NavItem to="https://tokensale.shping.com/referral-program.html">
      {I18n.t('nav.referral_program')}
    </NavItem>
    {config_parameters['links.ico_site'] && (
      <NavItem to={config_parameters['links.ico_site']}>{I18n.t('nav.ico_site')}</NavItem>
    )}
    {config_parameters['links.token_contact'] && (
      <NavItem to={config_parameters['links.token_contact']}>
        <Translate value="nav.token_contact" />
      </NavItem>
    )}
    {user_signed_in && (
      <NavItem to="/profile/payments">
        <Translate value="nav.payments" />
      </NavItem>
    )}
    {mobile &&
      user_signed_in && (
        <NavItem
          to="/"
          onClick={e => {
            e.preventDefault()
            signOut()
          }}
        >
          <Translate value="nav.log_out" />
        </NavItem>
      )}
    {mobile &&
      !user_signed_in && (
        <NavItem to="/users/sign_in">
          <Translate value="nav.sign_in" />
        </NavItem>
      )}
    <NavItem
      to="https://tokensale.shping.com/buy-shping-coins.html"
      linkClassName="btn btn-default"
    >
      {I18n.t('nav.buy_coins', { coin_name: config_parameters['coin.name'] })}
    </NavItem>
  </ul>
)

const Header = ({
  signOut,
  toggleLanguageDialog,
  toggleMobileMenu,
  setLocale,
  current_locale,
  user_signed_in,
  config_parameters,
  mobile_menu_opened,
  timer
}) => (
  <header>
    <span className="mobile-menu-action" onClick={e => e.preventDefault() || toggleMobileMenu()}>
      <i className="fa fa-bars" />
    </span>
    <div className={classNames('top-bar', { active: timer.active })}>
      <div>
        <label>{timer.label}</label>
        <Counter stop={moment(timer.stop).toDate()} />
      </div>
    </div>
    <div className="menu-bar">
      <ul>
        <li>
          <a href="https://www.shping.com/">{I18n.t('header.shping')}</a>
        </li>
        <li>
          <a href="https://www.shping.com/marketing">{I18n.t('header.shping_marketing')}</a>
        </li>
        <li>
          <a href="https://www.shping.com/security">{I18n.t('header.shping_security')}</a>
        </li>
        <li>
          <a href="https://tokensale.shping.com">{I18n.t('header.shping_token_sale')}</a>
        </li>
      </ul>
      <ul>
        {config_parameters['links.slack'] && (
          <li>
            <a href={config_parameters['links.slack']} className="social" target="_blank">
              <i className="fa fa-slack" /> <Translate value="header.slack" />
            </a>
          </li>
        )}
        {config_parameters['links.we_chat'] && (
          <li>
            <a href={config_parameters['links.we_chat']} className="social" target="_blank">
              <i className="fa fa-weixin" /> <Translate value="header.wechat" />
            </a>
          </li>
        )}
        {config_parameters['links.telegram'] && (
          <li>
            <a href={config_parameters['links.telegram']} className="social" target="_blank">
              <i className="fa fa-paper-plane" /> <Translate value="header.telegram" />
            </a>
          </li>
        )}
        <li>
          {user_signed_in && (
            <Link
              to="/"
              onClick={e => {
                e.preventDefault()
                signOut()
              }}
            >
              {I18n.t('nav.log_out')}
            </Link>
          )}
          {!user_signed_in && <Link to="/users/sign_in">{I18n.t('nav.sign_in')}</Link>}
        </li>
        <li>
          <a href="/" onClick={e => e.preventDefault() || toggleLanguageDialog()}>
            {I18n.t(`locale.${current_locale}`)}
          </a>
        </li>
      </ul>
    </div>
    <div className="down-bar">
      <a href="https://tokensale.shping.com" className="logo">
        {' '}
      </a>
      <MenuContainer className="main-menu" />
      <nav className="mobile-menu" style={{ display: mobile_menu_opened ? 'block' : 'none' }}>
        <MenuContainer mobile onClick={e => e.preventDefault() || toggleMobileMenu()} />
        <span
          className="mobile-menu-action"
          onClick={e => e.preventDefault() || toggleMobileMenu()}
        >
          <i className="fa fa-close" />
        </span>
      </nav>
    </div>
    <LanguageDialog />
  </header>
)

const getStageById = (ico_stages, id) => ico_stages.filter(stage => stage.id === id)[0]

const getTimerStart = ({ date_start, name }) => ({
  stop: date_start,
  label: I18n.t('header.timer_title_start', { stage_name: name }),
  active: false
})

const getTimerEnd = ({ date_end, name }) => ({
  stop: date_end,
  label: I18n.t('header.timer_title_end', { stage_name: name }),
  active: true
})

const getTimerData = ({ current_stage_id, ico_stages }) => {
  if (!current_stage_id) return {}
  if (current_stage_id < 2) {
    // pre sale starts
    return getTimerStart(getStageById(ico_stages, 2) || getStageById(ico_stages, current_stage_id))
  } else if (current_stage_id < 3) {
    // pre sale ends
    return getTimerEnd(getStageById(ico_stages, current_stage_id))
  } else if (current_stage_id < 4) {
    // crowd sale starts
    return getTimerStart(getStageById(ico_stages, 4) || getStageById(ico_stages, current_stage_id))
  } else {
    // crowd sale ends
    return getTimerEnd(getStageById(ico_stages, 8) || getStageById(ico_stages, current_stage_id))
  }
}

const mapStateToProps = state => ({
  current_locale: state.i18n.locale,
  user_signed_in: !!state.users.authorization,
  config_parameters: parametersSelector(state),
  mobile_menu_opened: state.translations.mobile_menu_opened,
  timer: getTimerData(jsonSelector('infos.system')(state))
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ signOut, toggleLanguageDialog, toggleMobileMenu, setLocale }, dispatch)

const MenuContainer = connect(mapStateToProps, mapDispatchToProps)(Menu)

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/containers/layouts/default/header/index.js